import {useDebouncedValue} from '@mantine/hooks';
import {useEffect, useRef} from 'react';
import {usePreviewBadgeTemplateMutation} from 'src/redux/queries/badgeTemplates';

const PREVIEW_DEBOUNCE_MS = 600;

export interface UseBadgeTemplatePreviewResult {
  html: string | undefined;
  mergeWarnings: string[];
  validationErrors: string[];
  validationWarnings: string[];
  isPreviewLoading: boolean;
  hasRequestedPreview: boolean;
}

export const useBadgeTemplatePreview = (
  htmlContent: string
): UseBadgeTemplatePreviewResult => {
  const [debouncedHtml] = useDebouncedValue(htmlContent, PREVIEW_DEBOUNCE_MS);
  const [previewBadgeTemplate, {data, isLoading}] =
    usePreviewBadgeTemplateMutation();
  const hasRequestedPreview = useRef(false);

  useEffect(() => {
    if (!debouncedHtml || !debouncedHtml.trim()) return;
    hasRequestedPreview.current = true;
    void previewBadgeTemplate({htmlContent: debouncedHtml});
    // previewBadgeTemplate is a stable dispatch ref from RTK Query
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedHtml]);

  return {
    html: data?.html,
    mergeWarnings: data?.mergeWarnings ?? [],
    validationErrors: data?.validationErrors ?? [],
    validationWarnings: data?.validationWarnings ?? [],
    isPreviewLoading: isLoading,
    hasRequestedPreview: hasRequestedPreview.current,
  };
};
